var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112431_30064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5012 6.64217C23.2265 5.6012 22.4133 4.78434 21.3795 4.50602C19.5072 4 12.0036 4 12.0036 4C12.0036 4 4.49639 4 2.62771 4.50602C1.59398 4.78434 0.780723 5.6012 0.506024 6.64217C0 8.5253 0 12.4578 0 12.4578C0 12.4578 -2.06821e-07 16.3904 0.502409 18.2735C0.777108 19.3145 1.59036 20.1313 2.6241 20.4096C4.49639 20.9157 12 20.9157 12 20.9157C12 20.9157 19.5072 20.9157 21.3759 20.4096C22.4096 20.1313 23.2229 19.3145 23.4976 18.2735C24 16.3904 24 12.4578 24 12.4578C24 12.4578 24 8.5253 23.5012 6.64217ZM9.54578 16.0253V8.89036L15.8169 12.4578L9.54578 16.0253Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112431_30064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.dd48c02fbdc31a69676b1d1b6538b40f.svg";
export { ForwardRef as ReactComponent };